export default __webpack_public_path__ + "static/media/Arrow2.f6d66596.svg";